<section class="amount-row splash-form-row">
  <div class="cmnh-card simple gift-amount-card">
    <div class="card-body">
      <div class="cmnh-grid gift-amount-grid">
        <div class="gift-amount">
          <label class="gift-amount-heading">
            {{ "AMOUNT" | translate }}
          </label>

          @if (!gettingCampaign) {
          <div class="gift-amount-actions">
            @for (amount of donationAmounts; track amount) {
            <app-cmn-button class="gift-amount-button" size="large"
              [variant]="(amount === donation || (!donation && amount === defaultDonationAmount)) ? 'primary' : 'secondary'"
              (click)="setDonation(amount)">
              ${{ amount }}
            </app-cmn-button>
            }
            <app-cmn-button class="gift-amount-button" size="large" [variant]="donation === 'Other' ? 'primary' : 'secondary'"
              (click)="setDonation('Other')">
              {{ "OTHER" | translate }}
            </app-cmn-button>
          </div>
          } @else {
          <div class="campaign-loading" aria-live="polite">
            <span class="cmnh-spinner"></span>
          </div>
          }
          @if (donation === 'Other') {
          <app-cmn-input inputId="donationAmount" name="donationAmount" type="text" class="donation-amount-input"
            autofocus decimalOnly pattern="^(?=.*[1-9])\d*(?:\.\d{1,2})?$" placeholder="0.00" required min="0"
            inputmode="decimal" #donationAmount="ngModel" [(ngModel)]="transaction.donationAmount"
            [control]="donationAmount" [showError]="
              donationAmount.invalid &&
              (form.submitted || donationAmount.dirty || donationAmount.touched)
            " (valueChanged)="
              clampDonationAmount($event);
              onDonationAmountChange.emit()
            "></app-cmn-input>
          }

          <div class="gift-amount-choice-group">
            <app-cmn-selector [checked]="transaction.chargeFrequency === 2"
              [label]="'SPLASH_MONTHLY_GIFT_1' | translate" [description]="'SPLASH_MONTHLY_GIFT_2' | translate"
              ariaLabel="Toggle monthly gift" [featured]="true" (toggled)="toggleChargeFrequency()"></app-cmn-selector>
          </div>

          <div class="gift-amount-choice-group gift-amount-choice-group-compact" [hidden]="drtv">
            <app-cmn-selector [checked]="!transaction.displayInDash" [label]="'SPLASH_ANONYMOUSLY' | translate"
              ariaLabel="Toggle anonymous gift" (toggled)="toggleAnonymousGift()"></app-cmn-selector>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>